module.exports = __webpack_public_path__ + "img/Example01.aaa9854c.png";